"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("./helpers");

var _classnames = _interopRequireDefault(require("classnames"));

var _debounce = _interopRequireDefault(require("debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// check if client body width is >= 1200
var isMXL = typeof document !== 'undefined' ? document.body.clientWidth >= 1200 : false;

var OnThisPage = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(OnThisPage, _React$PureComponent);

  var _super = _createSuper(OnThisPage);

  function OnThisPage(props) {
    var _this;

    _classCallCheck(this, OnThisPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setActiveLink", function () {
      var topOffset = _this.props.topOffset;
      var activeHeaderAnchor = (0, _helpers.getActiveHeaderAnchor)(topOffset); // if activeHeaderAnchor has an id, set it as the lastActiveLink

      if (activeHeaderAnchor && activeHeaderAnchor.id) {
        _this.setState({
          lastActiveLink: activeHeaderAnchor.id
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isActive", function (heading) {
      var lastActiveLink = _this.state.lastActiveLink;
      return heading.children && heading.children.filter(function (f) {
        return f.id === lastActiveLink;
      }).length > 0 || heading.id === lastActiveLink;
    });

    _this.state = {
      lastActiveLink: undefined
    };
    return _this;
  }

  _createClass(OnThisPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // on larger screens
      if (isMXL) {
        // create a debounced event listener on "scroll"
        this.onScroll = (0, _debounce.default)(this.setActiveLink, 50);
        document.addEventListener('scroll', this.onScroll); // set active link on load

        this.setActiveLink();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // on larger screens, tear down event listener
      if (isMXL) document.removeEventListener('scroll', this.onScroll);
    } // set the active link based on the heading that is scrolled into view

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          headings = _this$props.headings,
          themeWrapper = _this$props.themeWrapper;
      var lastActiveLink = this.state.lastActiveLink;
      if (!headings) return /*#__PURE__*/_react.default.createElement("div", null);
      var sections = (0, _helpers.buildSections)(headings);

      var Headings = function Headings(_ref) {
        var headings = _ref.headings,
            isChild = _ref.isChild,
            active = _ref.active;

        if (!headings || !headings.length) {
          return null;
        }

        return /*#__PURE__*/_react.default.createElement("ul", {
          className: (0, _classnames.default)('', {
            none: isChild && !active,
            'block pl12': isChild && active,
            my6: isChild
          })
        }, headings.map(function (heading) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: heading.id,
            className: (0, _classnames.default)('mb3', {
              'mb6-mxl': !isChild
            })
          }, /*#__PURE__*/_react.default.createElement("a", {
            style: {
              wordBreak: 'break-word'
            },
            href: "#".concat(heading.id),
            className: (0, _classnames.default)('link inline-block', {
              'link--blue': heading.id === lastActiveLink,
              'link--gray': heading.id !== lastActiveLink
            })
          }, heading.icon && /*#__PURE__*/_react.default.createElement(_helpers.HeadingIcon, {
            name: heading.icon
          }), heading.value), /*#__PURE__*/_react.default.createElement(Headings, {
            isChild: true,
            active: _this2.isActive(heading),
            headings: heading.children
          }));
        }));
      };

      return /*#__PURE__*/_react.default.createElement("nav", {
        "aria-labelledby": "on-this-page",
        className: "dr-ui--on-this-page ".concat(themeWrapper)
      }, /*#__PURE__*/_react.default.createElement(_helpers.AsideHeading, {
        id: "on-this-page"
      }, "On this page"), /*#__PURE__*/_react.default.createElement(Headings, {
        headings: sections
      }));
    }
  }]);

  return OnThisPage;
}(_react.default.PureComponent);

exports.default = OnThisPage;
OnThisPage.propTypes = {
  /** Array of headings */
  headings: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    slug: _propTypes.default.string.isRequired,
    children: _propTypes.default.arrayOf(_propTypes.default.shape({
      text: _propTypes.default.string.isRequired,
      slug: _propTypes.default.string.isRequired,
      icon: _propTypes.default.string
    }))
  })),

  /** Assembly classes to apply to the containing wrapper */
  themeWrapper: _propTypes.default.string,

  /** Threshold that the anchor must pass to be considered the active anchor */
  topOffset: _propTypes.default.number
};
OnThisPage.defaultProps = {
  topOffset: 50,
  themeWrapper: ''
};